import { Button, ButtonProps, Card } from "antd";
import { ReactNode } from "react";

interface Props extends Omit<ButtonProps, "title"> {
  title: ReactNode;
  children: ReactNode;
}

export default function CardButton({ title, children, ...props }: Props) {
  return (
    <Button className="h-fit w-full px-0" {...props}>
      <Card className="w-full h-full" title={title}>
        {children}
      </Card>
    </Button>
  );
}
